import { render, staticRenderFns } from "./sports_schedules.vue?vue&type=template&id=2858e6e2&scoped=true"
import script from "./sports_schedules.vue?vue&type=script&lang=js"
export * from "./sports_schedules.vue?vue&type=script&lang=js"
import style0 from "./sports_schedules.vue?vue&type=style&index=0&id=2858e6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2858e6e2",
  null
  
)

export default component.exports